import { get } from 'lodash-es';

export const getCoverPreviewPayload = (response) => {
  // TODO: To be used with the autosave for avoiding requesting without changes
  const timestamp = Date.now();
  const urls = get(response, 'data.data', {});

  return { urls, timestamp };
};
